module.exports = __webpack_public_path__ + "d70d31d5deb295f1e5b0fb76d4a23edc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-ringlets-black.png
// module id = 2229
// module chunks = 0